import React from "react";
import { ReportDataConsumer } from "../services/report-data-service-provider";
import ErrorBoundary from "../components/error-boundary";

const withDataServiceConsumer = errorCaptionKey => Wrapped => {
    return props => (
        <ErrorBoundary fillParent errorCaptionKey={errorCaptionKey}>
            <ReportDataConsumer>
                {({ dataService, signalService, conclusionService }) => {
                    return <Wrapped {...props} {...{ dataService, signalService, conclusionService }} />;
                }}
            </ReportDataConsumer>
        </ErrorBoundary>
    );
};

export default withDataServiceConsumer;
